import { invokeFunction } from "./utils";

export class CCForm {
  constructor(el, options = {}) {
    this.el = el;
    this.options = options
    this.state = null

    const height = options.height || 38

    const iframe = this.iframe = document.createElement('iframe');
    iframe.frameBorder = 0

    const url = options.local ? '/form.html': 'https://d3f1x7meex37wo.cloudfront.net/form.html'

    iframe.src = url
    iframe.height = 44
    
    if (el) {
      this.attach(el)
    }

    iframe.onload = () => {
      if (options.noCVV) {
        invokeFunction('removeCVV', [], this.iframe)
      }
    }

    this.subscribers = {}

    window.addEventListener('message', (e) => {
      try {
        const payload = JSON.parse(e.data)

        if (payload.event) {
          
          if (payload.event == 'resize') {
            iframe.height = 90
            return
          }

          const subscribers = this.subscribers[payload.event] || []

          for (const subscriber of subscribers) {
            subscriber(payload.payload)
          }
        }
      }
      catch (_e) {
        //
      }
    })

    this.on('state', ({ state }) => {
      this.state = state;
    })
  }

  attach(el) {
    el.appendChild(this.iframe)
  }

  on (event, subscriber) {
    this.subscribers[event] = this.subscribers[event] || []

    this.subscribers[event].push(subscriber)

  }

  async createToken (input, test_mode = false, raw_mode = false) {
    if (this.state === 'submitting') return;
    const result = await invokeFunction('createToken', [input, test_mode, raw_mode], this.iframe)

    if (result.error) {
      throw new Error(result.error)
    }

    return result
  }

  setRawMode(rawMode) {
    invokeFunction('setRawMode', [rawMode], this.iframe)
  }

  reset () {
    invokeFunction('reset', [], this.iframe)
  }
}